<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card" ref="formContainer">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4 col-sm-4 col-12">
                <div class="form-group">
                  <label>Voucher Code</label>
                  <b-form-input
                    type="text"
                    v-model="form.vouchercode"
                    
                  />
                </div>
              </div>
              <div class="col-lg-4 col-sm-4 col-12">
                <div class="form-group">
                  <label>Issue Date</label>
                  <div>
                    <b-form-input
                      type="date"
                      v-model="form.dispatchdate"
                      placeholder="Select dispatch date"
                      
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(forms, index) in form.issues" :key="index">
              <div class="row">
                <div class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    <span
                      @click="removeForm(index)"
                      v-if="index > 0"
                      class="col-md-1 col-sm-2 mobile"
                      ><img
                        src="../../../assets/img/icons/x.svg"
                        alt="close"
                        class="hover-darken tt"
                        data-bs-placement="top"
                        title="Remove"
                    /></span>
                    <label>Item Name</label>
                    <div>
                      <model-list-select
                        :list="itemListFromApi"
                        v-model="forms.dispatchitem"
                        option-value="itemid"
                        option-text="itemname"
                        placeholder="Select item"
                        :ref="`dispatchitemInput${index}`"
                        tabindex="1"
                        autofocus
                        @keypress.enter="submitForm()"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Department</label>
                    <div>
                      <model-list-select
                        :list="DeptList"
                        v-model="forms.department"
                        option-value="deptid"
                        option-text="deptname"
                        placeholder="Select department"
                        
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-2 col-6">
                  <div class="form-group">
                    <label>Quantity</label>
                    <span
                      data-bs-placement="top"
                      title="Enter the Quantity or Press the 'Enter' key to add another item"
                      ><b-form-input
                        type="number"
                        v-model.number="forms.quantity"
                        min="0"
                        max="999999.99"
                        @input="validateQuantity(forms)"
                        @keyup.enter="addForm"
                    /></span>
                  </div>
                </div>
                <span
                  v-if="index > 0"
                  @click="removeForm(index)"
                  class="col-md-1 col-lg-1 col-sm-2 desktop tt"
                  data-bs-placement="top"
                  title="Remove"
                  ><img
                    src="../../../assets/img/icons/x.svg"
                    alt="close"
                    class="hover-darken"
                />
              </span>

              </div>
              <hr style="border-top: 4px solid #000; margin: 10px 0px" />

            </div>
            <div class="row">
              <span
                @click="addForm"
                class="col-md-2 col-sm-2 d-flex align-items-center mb-4 hover-darken tt"
                data-bs-placement="top"
                title="Add"
              >
                <img
                  src="../../../assets/img/icons/plus-circle.svg"
                  alt="close"
                  class="mx-1"
                />
                Add Item</span
              >
            </div>

            <!-- <button  class="btn btn-success me-2">
              Add More
            </button> -->
            <button @click="submitForms" class="btn btn-primary me-2">
              Submit All
            </button>
            <router-link to="saleslist" class="btn btn-secondary"
              >Cancel</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tt {
  cursor: pointer;
  height: fit-content;
}

.hover-darken {
  transition: all 0.3s ease;
}

.hover-darken:hover {
  filter: brightness(0.7);
}
.desktop {
  display: inline-block;
  justify-content: center;
}
.mobile {
  display: none;

  justify-content: end;
}
@media (max-width: 576px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
}
</style>

<script>
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

export default {

  data() {  
  const today = new Date();
    return {
      form: {
        vouchercode: "",
        dispatchdate: `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`,        issues: [{ dispatchitem: "", quantity: "0", department: "" }],
      },
      title: "Issue Item",
      title1: "Create new Issue Item",
      DeptList: [],
      itemListFromApi: [],
    };
  },
  computed:{
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
  created() {
    this.fetchItemListFromApi();
    this.fetchDeptListFromApi();
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
    this.$nextTick(() => this?.$refs[`dispatchitemInput0`][0].$el.focus());//Focus on first input
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (
        this.$route.path === "/add-sales" &&
        event.ctrlKey &&
        (event.key === "m" || event.key === "M")
      ) {
        event.preventDefault();
        this.addForm();
      }
    },
    validateQuantity(form) {
      const quantity = parseFloat(form.quantity);
      if (quantity < 0) {
        Swal.fire({
          icon: "error",
          title: "Invalid Quantity",
          text: "Quantity must be a positive number.",
        });
        form.quantity = Math.max(quantity, 0);
      }
    },
    addForm() {
      if (this.form.issues.length < 20) {
        this.form.issues.push({
          dispatchitem: " ",
          quantity: "0",
          department: " ",
        });
        this.$nextTick(() => {
          const newIndex = this.form.issues.length - 1;
          this.$refs[`dispatchitemInput${newIndex}`][0].$el.focus();
        });
      }
      if (this.form.issues.length >= 20) {
        Swal.fire("You can add a maximum of 20 forms.");
      }
    },
    removeForm(index) {
      this.form.issues.splice(index, 1);
    },
    async fetchItemListFromApi() {
      try {
        const response = await axios.get(`/v1/items?locationid=${this.locationId}`);
        this.itemListFromApi = response.data; 
      } catch (error) {
        console.error("Error fetching item list:", error);
      }
    },
    async fetchDeptListFromApi() {
      try {
        const response = await axios.get(`/v1/departments?locationid=${this.locationId}`);
        this.DeptList = response.data; 
      } catch (error) {
        console.error("Error fetching item list:", error);
      }
    },
  
    
    async submitForms() {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to submit the form?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
      });

      if (result.isConfirmed) {
      console.log(this)
        const selectedDate = moment(this.dispatchdate).format(
            "YYYY-MM-DD"
          );
          const currentTime = moment().format("HH:mm:ss");
        const allFormData = this.form.issues.map((issue) => ({
          dispatchitem: issue.dispatchitem,
          locationid:this.locationId,
            quantity: issue.quantity,
            vouchercode: this.form.vouchercode,
            department: issue.department,
            dispatchdate: `${selectedDate}T${currentTime}`,
    }));
        this.postData(allFormData);
      }
    },  submitForm() {
      this.submitForms();
    },
    postData(forms) {
      axios
        .post("/v1/dispatches", forms)
        .then((response) => {
          //this.res = "Status " + response.status + ". Category created";
          Swal.fire("Issue Item created successfully");
          this.$router.push({ path: "/saleslist" });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire(error.response.data.detail);
        });
    },
    submitForm() {
      this.submitForms();
    }
    
  },
  components: {
    ModelListSelect,
  },

  name: "add-sales",
};
</script>
